import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { CHECKOUT_URL, PRODUCT_IMG } from './constants';
export function FinalCTA() {
  return <section className="bg-ev-black px-4 py-4 text-white" data-id="element-49" data-mp="c6iuzupli37o">
      <div className="mx-auto max-w-3xl text-center" data-id="element-50" data-mp="c83qbmjqhq6l">
        <h2 className="mb-1.5 font-display text-[21px] leading-tight text-white sm:text-3xl" data-id="element-51" data-mp="84xkuh4g4316">
          One Last Question
        </h2>
        <p className="mb-2.5 text-[13px] font-medium leading-snug text-ev-steel sm:text-[15px]" data-id="element-52" data-mp="m3dr66yebris">
          When another EV or hybrid fault appears... Do you immediately know which system needs
          attention first? Stop jumping between scattered references and guessing where the problem
          starts. Open the system. Find the symptom. Follow the diagnostic path.{' '}
          <span className="font-bold text-white" data-id="element-53" data-mp="14whkfr7pc2cv">Identify. Test. Diagnose.</span>
        </p>

        <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="mb-2 block" aria-label="Get EV &amp; Hybrid Diagnostic Pro" data-id="element-54" data-mp="zxehqdf72882">
          <img src={PRODUCT_IMG} alt="EV &amp; Hybrid Diagnostic Pro complete 6-in-1 system box set" className="mx-auto w-full max-w-[230px] object-contain drop-shadow-2xl transition-transform duration-150 ease-out hover:scale-[1.02] sm:max-w-[320px]" data-id="element-55" data-mp="2h4suuvjjai0n" />
        </a>

        <p className="font-cond text-2xl tracking-wide text-ev-green sm:text-3xl" data-id="element-56" data-mp="2v2ziliurr1ml">
          ⚡ EV &amp; HYBRID DIAGNOSTIC PRO™
        </p>
        <h3 className="mb-1 font-display text-[17px] leading-tight text-white sm:text-2xl" data-id="element-57" data-mp="34tc0f3b78gp1">
          The Complete Visual Troubleshooting System for EV &amp; Hybrid Technicians
        </h3>
        <p className="mb-2.5 text-[12px] font-bold uppercase tracking-[0.12em] text-ev-steel sm:text-sm" data-id="element-58" data-mp="39u9hfckh34oy">
          Understand • Identify • Test • Isolate • Diagnose • Verify
        </p>

        <p className="mb-1.5 font-cond text-xl tracking-wide text-ev-neon sm:text-2xl" data-id="element-59" data-mp="3ir0kwa1ctltk">
          🔥 GET THE COMPLETE SYSTEM TODAY
        </p>
        <CTAButton href={CHECKOUT_URL} external className="mx-auto max-w-md" subLabel="Immediate Access • Digital Delivery" data-id="element-60" data-mp="1eps7x7c8zwlt">
          ⚡ GET EV &amp; HYBRID DIAGNOSTIC PRO™
        </CTAButton>
        <p className="mt-2 flex items-center justify-center gap-1 text-[11px] font-bold uppercase tracking-wide text-ev-steel sm:text-xs" data-id="element-61" data-mp="1nodkmlv1gheo">
          <ShieldCheckIcon aria-hidden="true" className="h-4 w-4 text-ev-green" data-id="element-62" data-mp="1xfqd9fonvblr" />
          7-Day Money-Back Guarantee
        </p>
      </div>
    </section>;
}